export default __webpack_public_path__ + "static/media/3.cf0608f4.JPG";